import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface IdeaSorting {
  field:
    | 'none'
    | 'title'
    | 'status'
    | 'originator'
    | 'created_at'
    | 'comments'
    | 'team'
    | 'followers';
  dir: 'asc' | 'desc';
}

@Component({
  selector: 'app-idea-bar-controls',
  templateUrl: './idea-bar-controls.component.html',
  styleUrls: ['./idea-bar-controls.component.scss'],
})
export class IdeaBarControlsComponent {
  @Input() sorting: IdeaSorting = {
    field: 'none',
    dir: 'desc',
  };
  @Output() sortingChanged = new EventEmitter<IdeaSorting>();

  setSort(field) {
    if (this.sorting.field === field) {
      this.sorting.dir = this.sorting.dir === 'asc' ? 'desc' : 'asc';
    } else {
      this.sorting.field = field;
      this.sorting.dir = 'desc';
    }

    this.sortingChanged.emit(this.sorting);
  }
}
